import React, { PropsWithChildren } from 'react';
import { Box, BoxProps } from '@mui/material';
import { styled } from '@mui/styles';
import ReactPlayer from 'react-player';
import { IVideoDisplayViewModel } from '../../../dataObjects/viewModels/videoDisplayViewModel';


/*** Using the Material UI Emotion Styling library, declare 'styled' instances for each area/object. 
 *** NOTE: These must be declared outside of the React Functional Component to ensure that the styled 
 *** objects will be properly rendered within the DOM. 
 ***/

// a styled Box (equivalent to a <div>) that will serve as a base container in a Card View
const StyledContainerForCardView = styled((props: BoxProps) => (
  <Box
    {...props}
  />
))(({ theme }) => ({
  margin: theme.spacing(0, 0, 2, 0),
  border: `2px solid ${theme.palette.primary.main}`,
  borderRadius: '1px',
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
  flexGrow: 1,
  position: 'relative',
  height: '250px',
  width: 'auto'
}));

/**
 * @interface IEducationalVideoMediaDisplayProps declares any input properties required for this component.
 */
export interface IEducationalVideoMediaDisplayProps extends PropsWithChildren<unknown> {
  videoDisplayViewModel: IVideoDisplayViewModel;
}

/**
 * @function EducationalVideoMediaDisplay is a React functional component for displaying a simple video (via an IVideoLink).
 * @param {} props are the properties passed into the component (currently no input properties).
 */
export const EducationalVideoMediaDisplay: React.FC<IEducationalVideoMediaDisplayProps> = (props: IEducationalVideoMediaDisplayProps) => {
  EducationalVideoMediaDisplay.displayName = 'Video Media Display';

  // whether to display console logs (displayConsoleLogs && console.log statements)
  const displayConsoleLogs: boolean = false;

  displayConsoleLogs && console.log(`EducationalVideoMediaDisplay. Entered EducationalVideoMediaDisplay`);

  const { videoDisplayViewModel } = props;

  const videoNotAvailableWidth: string = `100%`;
  const videoNotAvailableHeight: string = `100%`;

  /**
   * @function renderVideoElement Renders the JSX element of the video object to be displayed on the UI.
   */
  function renderVideoElement(): React.JSX.Element {

    // default the video element to displaying no video
    let videoElement: React.JSX.Element =
      <>
      </>;

    // if there's an established Url for the object, perform logic
    if (videoDisplayViewModel.displayUrl) {

      videoElement =
        <>
          <ReactPlayer
            url={videoDisplayViewModel.displayUrl}
            crossOrigin="anonymous"
            playsinline={true}
            controls={true}
            position='relative'
            width='100%'
            height='100%'
          />
        </>
    }

    return videoElement;
  }


  return (
    <>
      <StyledContainerForCardView >
        {renderVideoElement()}
      </StyledContainerForCardView>
    </>
  )
}
